// extracted by mini-css-extract-plugin
module.exports = {"articleVideo":"ArticleVideo_articleVideo__Yv5bW"};